module.exports = __webpack_public_path__ + "assets/824fa96b59266159e3db0de7d4141b3d.mp3";